import { render, staticRenderFns } from "./VersionsList.vue?vue&type=template&id=4847df71&scoped=true"
import script from "./VersionsList.vue?vue&type=script&lang=js"
export * from "./VersionsList.vue?vue&type=script&lang=js"
import style0 from "./VersionsList.vue?vue&type=style&index=0&id=4847df71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4847df71",
  null
  
)

export default component.exports